<template lang="pug">
v-layout(row, wrap).mt-2
  v-flex.xs-12(v-if="!listRepasses.length")
    span.font-weight-medium.Poppins Você não possui repasses nesse período.
  v-flex.xs12(v-else)
    v-card.pa-2.mb-3.cardFatura(v-for="repasse in listRepasses", :key="repasse.fatura_id")
      v-layout.pa-2(justify-center, align-center, style="cursor: pointer;", @click="repasse.config.action ? repasse.config.action(repasse) : function(){}")
        v-flex.md8.xs8
          .title.font-weight-medium.Poppins {{ repasse.config.label }}
          .caption.font-weight-medium.Poppins.mt-1(v-if="repasse.config.date") {{ $dayjs(repasse.data_inicio).format('DD/MM/YYYY') }} até {{ $dayjs(repasse.data_fim).format('DD/MM/YYYY') }}
          .body-1.gray--text.Poppins.mt-2(v-html="repasse.config.desc")
        v-flex.md3.xs3.pa-0.ma-0(style="display: flex; align-items: center;justify-content: center;", align-left)
          v-chip(:style="{'color': repasse.config.fontColor, 'background': repasse.config.badgeColor}").subheading.font-weight-medium.Poppins {{ repasse.valor | currency }}
        v-flex.md1.xs1.pa-0.ma-0(style="display: flex; align-items: center;justify-content: right;")
          v-icon(large, color="black", v-if="repasse.config.hasAction") chevron_right

  DialogComprovante(ref="dialogComprovante", @showFatura="showFaturaDetail")
  Antecipacao(ref="dialogAntecipacao", @showFatura="showFaturaDetail")
</template>

<script>

import Antecipacao from '@/pages/financeiro/fatura/Antecipacao';
import DialogComprovante from '@/pages/financeiro/fatura/DialogComprovante';

export default {
  components: {
    Antecipacao,
    DialogComprovante
  },
  props: {
    showFatura: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
      faturas : []
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
    listRepasses () {
      const vm = this;
      const faturas = [...vm.faturas].sort((a,b) => {
        return vm.$dayjs(b.data_fim) - vm.$dayjs(a.data_fim);
      });
      const repasses = [];
      faturas.forEach(fatura => {
        fatura.repasses.forEach(_repasse => {
            const repasse = _.cloneDeep(_repasse);
            repasse.fatura = fatura;
            repasse.config = vm.setStatusRepasse(repasse);
            repasses.push(repasse);
        });
      });
      return repasses;
    },
  },
  methods: {
    refresh(faturas){
      const vm = this;
      vm.faturas = faturas;
    },
    showFaturaDetail(fatura){
      const vm = this;
      vm.$emit('showFatura', fatura);
    },
    openAntecipacao(repasse){
      const vm = this;
      const fatura = repasse.fatura;
      vm.$refs.dialogAntecipacao.open(fatura);
    },
    openComprovante(repasse){
      const vm = this;
      vm.$refs.dialogComprovante.open(repasse);
    },
    chatFianceiro(){
      window.open("https://api.whatsapp.com/send?phone=5532998196024", "_blank");
    },
    setStatusRepasse(repasse) {
      const vm = this;
      const colorLabel = []

      colorLabel['DISPONIVEL'] = {
        label: "Antecipação Disponível",
        desc: `Você poderá antecipar os valores a receber referentes aos pedidos do dia ${vm.$dayjs(repasse.fatura.data_inicio).format('DD/MM/YYYY')} até dia ${vm.$dayjs(repasse.fatura.data_fim).format('DD/MM/YYYY')}.`,
        badgeColor: '#32BA72',
        fontColor: '#FFF',
        hasAction: true,
        action: vm.openAntecipacao
      }
      colorLabel['INDISPONIVEL'] = {
        label: "Repasse ",
        desc: `Não é possível realizar repasses com valores inferiores a R$${vm.$options.filters.currency(vm.$root.enums.VALOR_MINIMO_REPASSE.toFixed(2))}.`,
        badgeColor: "#9A9A9A",
        fontColor: '#FFF',
      }
      colorLabel[vm.$root.enums.STATUS.REPASSE_AGUARDANDO] = {
        label: "Repasse Agendado",
        desc: `A transferência será realizada em ${vm.$dayjs(repasse.data_repasse).format("DD/MM/YYYY")}.`,
        badgeColor: '#FFF',
        fontColor: '#000',
      }
      colorLabel[vm.$root.enums.STATUS.REPASSE_REALIZADO] = {
        label: "Repasse Realizado",
        desc: `A transferência foi realizada em ${vm.$dayjs(repasse.data_pagamento).format("DD/MM/YYYY")}. Clique e veja o <span style="text-decoration: underline;">comprovante</span>.`,
        badgeColor: '#FFF',
        fontColor: '#000',
        hasAction: true,
        date: true,
        action: vm.openComprovante
      }
      colorLabel[vm.$root.enums.STATUS.SALDO_REMANESCENTE] = {
        label: "Repasse Retido",
        desc: `Não é possível realizar repasses com valores inferiores a R$${vm.$options.filters.currency(vm.$root.enums.VALOR_MINIMO_REPASSE.toFixed(2))}. Esse valor será acumulado para o próximo repasse.`,
        badgeColor: "#9A9A9A",
        fontColor: '#FFF',
      }
      colorLabel[vm.$root.enums.STATUS.REPASSE_ERRO] = {
        label: "Erro ao Processar o Repasse",
        desc: `Tivemos um problema ao realizar o repasse. Por favor, <span style="text-decoration: underline;">clique aqui para falar com o financeiro</span>.`,
        badgeColor: "#F7B32B",
        fontColor: '#FFF',
        hasAction: true,
        date: true,
        action: vm.chatFianceiro
      };
      let res =  colorLabel[repasse.status] || {backgroundcolor:'',color: '', label: ''};
      if (!repasse.id && repasse.status == vm.$root.enums.STATUS.REPASSE_AGUARDANDO && repasse.fatura.antecipada) res = colorLabel['DISPONIVEL']
      if (!repasse.id && repasse.status == vm.$root.enums.STATUS.REPASSE_AGUARDANDO && !repasse.fatura.antecipada) res = colorLabel[vm.$root.enums.STATUS.REPASSE_AGUARDANDO]
      if (!repasse.id && repasse.status == vm.$root.enums.STATUS.SALDO_REMANESCENTE) res = colorLabel['INDISPONIVEL']
      if (repasse.valor < vm.$root.enums.VALOR_MINIMO_REPASSE && !repasse.id) res = colorLabel['INDISPONIVEL']
      return res
    }
  }
}
</script>
